<template>
    <div id="Logo">
        <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
        <h2 title="HOME"><a href="/" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

        <siteMenu v-bind:selectedid="selectedid"></siteMenu>
    </div>
</template>
<script>
import $ from "jquery";
import SiteMenu from "components/common/sitemenu";
export default {
  name: "Logo",
  components: {
    SiteMenu
  },
  props: ["selectedid"],
  watch: {
    $route(to, from) {
      if (to.path.indexOf("company") >= 0) {
        $("body").attr("class", "company");
      } else if (to.path.indexOf("service") >= 0) {
        $("body").attr("class", "service");
      } else if (to.path.indexOf("product") >= 0) {
        $("body").attr("class", "product");
      } else if (to.path.indexOf("media") >= 0) {
        $("body").attr("class", "media");
      } else {
        $("body").attr("class", "company");
      }
    },
    mounted() {
      console.log("beforeunloadHandler");
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/common/logo.vue